import * as React from 'react';
import { useMemo, FC } from 'react';
import { compose } from 'recompose';
import { EnhancedExportButton } from '@components/exportButton/ExportButton';
import { withNotifications } from '@components/hoc/withNotifications';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

type Props = Record<string, any>;

const View: FC<Props> = ({ state }) => {
  const params = useMemo(
    () => ({
      sort: state.sort,
      order: state.order,
      page: state.page,
      pageSize: state.pageSize,
      filters: state.filters,
      checkedItems: state.checkedItems
    }),
    [state]
  );

  return (
    <>
      <ColumnManager agenda={Agenda.EMPLOYEES} />
      <EnhancedExportButton location={'employeeOverview'} params={params} />
    </>
  );
};

export const ActionBar = compose(withNotifications({}))(View);



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesGridButtons.tsx